import React, {Component, PropTypes} from 'react';

export default class NavToggle extends Component {
  static displayName = 'NavToggle';
  static propTypes = {};
  static defaultProps = {};

  render() {
    return (
      <span className="nav-toggle">
        <span/>
        <span/>
        <span/>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/navigation/NavToggle.jsx